import React from 'react';
import Wrapper from './styles';
import { useLanguageContext } from '../../context/language_context';

const CartColumns = () => {
  const { t } = useLanguageContext();
  
  return (
    <Wrapper>
      <div className='content'>
        <h5>{t.cart.item}</h5>
        <h5>{t.cart.price}</h5>
        <h5>{t.cart.quantity}</h5>
        <h5>{t.cart.subtotal}</h5>
        <span></span>
      </div>
    </Wrapper>
  );
};

export default CartColumns;
